module.exports = __webpack_public_path__ + "img/lottoballs-bg.2add202e.png";